var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 1.98438C16.5469 1.98438 17.0156 2.1875 17.3906 2.59375C17.7969 2.96875 18 3.4375 18 4V18.0156C18 18.5469 17.7969 19.0156 17.3906 19.4219C17.0156 19.7969 16.5469 19.9844 15.9844 19.9844H2.01562C1.45312 19.9844 0.96875 19.7969 0.5625 19.4219C0.1875 19.0156 0 18.5469 0 18.0156V4C0 3.4375 0.1875 2.96875 0.5625 2.59375C0.96875 2.1875 1.45312 1.98438 2.01562 1.98438H3V0.015625H5.01562V1.98438H12.9844V0.015625H15V1.98438H15.9844ZM15.9844 18.0156V7.98438H2.01562V18.0156H15.9844ZM6 12.0156V10H3.98438V12.0156H6ZM9.98438 12.0156V10H8.01562V12.0156H9.98438ZM14.0156 12.0156V10H12V12.0156H14.0156ZM6 16V13.9844H3.98438V16H6ZM9.98438 16V13.9844H8.01562V16H9.98438ZM14.0156 16V13.9844H12V16H14.0156Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f1191be1d5c859ebd49dff238ad93e29.svg";
export { ForwardRef as ReactComponent };